module.exports = __webpack_public_path__ + "static/port-stats-8012fb0d59885a616384cbfa4e36a924.jpg";